import { render } from "./ManagementsMain.vue?vue&type=template&id=01ec9d63"
import script from "./ManagementsMain.vue?vue&type=script&lang=js"
export * from "./ManagementsMain.vue?vue&type=script&lang=js"

import "./ManagementsMain.vue?vue&type=style&index=0&id=01ec9d63&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__